import { render } from "./MdTableEmptyState.vue?vue&type=template&id=c590021e"
import script from "./MdTableEmptyState.vue?vue&type=script&lang=js"
export * from "./MdTableEmptyState.vue?vue&type=script&lang=js"

import "./MdTableEmptyState.vue?vue&type=style&index=0&id=c590021e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__